import { AxiosResponse } from 'axios';
import { workspaceServiceClient } from 'services/backofficeIntegration/http/client/createWorkspaceServiceClient';
import { mutationEndpoint } from 'services/backofficeIntegration/http/endpointDefinition';
import { type PostV1WorkspacesResponses } from 'services/generated/workspace-service';

export const httpCreateWorkspace = mutationEndpoint({
  callEndpoint: () =>
    workspaceServiceClient
      .post<
        PostV1WorkspacesResponses['201'],
        AxiosResponse<PostV1WorkspacesResponses['201']>,
        {
          name: string;
        }
      >('/v1/workspaces', {
        name: 'New Workspace',
      })
      .then(response => response.data),
});
